module.exports = __webpack_public_path__ + "static/Papaya Global-d99f335c17b55d27d1dedd69f81b1d6a.jpg";